import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme) => ({
  root: { display: 'flex', justifyContent: 'center' },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    textAlign: 'center',
    maxWidth: ({ width }: any) => width,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
    },
  },
}));

interface Props {
  width?: string | number;
  children: React.ReactNode;
}

export default function ContentContainer({ width = '100%', children }: Props) {
  const classes = useStyles({ width });
  return (
    <div className={classes.root}>
      <Container className={classes.container}>{children}</Container>
    </div>
  );
}
